
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowTopLeft as ObiArrowTopLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-top-left.js';
 
 
 

 
 export const ObiArrowTopLeft = createComponent({
   react: React,
   tagName: 'obi-arrow-top-left',
   elementClass: ObiArrowTopLeftElement,
   events: {
     
   }
  });
 
 